import { render, staticRenderFns } from "./BlockNew.vue?vue&type=template&id=0700c6e6&"
import script from "./BlockNew.vue?vue&type=script&lang=js&"
export * from "./BlockNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports